import { IdealDateCompatibilityOptionsType } from './types';

export const IDEAL_DATE_COMPATIBILITY_OPTIONS: IdealDateCompatibilityOptionsType =
  [
    { id: 'dinner_dessert', title: 'Dinner... then dessert on her thighs' },
    { id: 'no_plans_hands', title: 'No plans — just hands everywhere' },
    {
      id: 'movie_not_watching',
      title: 'Movie playing, but neither of you watching',
    },
  ];
